// extracted by mini-css-extract-plugin
module.exports = {"seller":"styles_seller__3P5eC"};